import createReducer from 'arts/config/create_reducer';
import Constants from 'arts/config/constants';
import { updateCollectionStoreItems } from './utils';

const getDefaultState = () => ({
  loading: false,
  collection: [],
  page: 0,
  prevPage: 0,
  totalPages: -1
});

const wallsReducer = createReducer(getDefaultState(), {
  [Constants.Walls.FETCH](state) {
    return {
      ...state,
      loading: true
    };
  },

  [Constants.Walls.FETCH_SUCCESS](state, { walls, page, totalPages }) {
    return {
      ...state,
      loading: false,
      collection: walls,
      page,
      prevPage: state.page,
      totalPages
    };
  },

  [Constants.WallStoreItems.ADDED](state, { wallId, storeItemId }) {
    return {
      ...state,
      walls: updateCollectionStoreItems(state.walls, wallId, storeItemId)
    };
  },

  [Constants.WallStoreItems.REMOVED](state, { wallId }) {
    return {
      ...state,
      walls: updateCollectionStoreItems(state.walls, wallId, null)
    };
  },

  [Constants.Walls.RESET]() {
    return getDefaultState();
  }
});

export default wallsReducer;
